import { HttpClient } from '@store/base';
import _ from 'lodash';
import querystring from 'query-string';
import {
  GetGoodsDefaultInfoRequest,
  GetGoodsDefaultInfoResponse,
  GetGoodsDetailInfoRequest,
  GetGoodsDetailInfoResponse,
  GetGoodsExchangeReturnPolicyRequest,
  GetGoodsExchangeReturnPolicyResponse,
  GetGoodsPurchaseEssentialInfoRequest,
  GetGoodsPurchaseEssentialInfoResponse,
  GetGoodsRecommendInfoRequest,
  GetGoodsRecommendInfoResponse,
} from '../../model';

export class GetGoodsDefaultInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsDefaultInfoRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    return await this.httpClient.request<GetGoodsDefaultInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v4/goods/${req.gdsNo}/detail/default-info?${query}`,
    });
  }
}

export class GetGoodsDetailInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsDetailInfoRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    return await this.httpClient.request<GetGoodsDetailInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/detail/detail-info?${query}`,
    });
  }
}

export class GetGoodsRecommendInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsRecommendInfoRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    return await this.httpClient.request<GetGoodsRecommendInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/detail/recommend-info?${query}`,
    });
  }
}

export class GetGoodsPurchaseEssentialInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsPurchaseEssentialInfoRequest) {
    return await this.httpClient.request<GetGoodsPurchaseEssentialInfoResponse>(
      {
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/infos/purchase-essential-info`,
      },
    );
  }
}

export class GetGoodsExchangeReturnPolicyGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsExchangeReturnPolicyRequest) {
    return await this.httpClient.request<GetGoodsExchangeReturnPolicyResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/infos/exchange-return-policy`,
    });
  }
}
